import { render, staticRenderFns } from "./TagEditView.vue?vue&type=template&id=fa1c7aba&scoped=true"
import script from "./TagEditView.vue?vue&type=script&lang=js"
export * from "./TagEditView.vue?vue&type=script&lang=js"
import style0 from "./TagEditView.vue?vue&type=style&index=0&id=fa1c7aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1c7aba",
  null
  
)

export default component.exports